import { createAsyncThunk } from '@reduxjs/toolkit';
import { LoanOfferApi } from 'api/LoanOfferApi';
import RequestError from 'errors/RequestError';

import { ErrorResponse } from './ErrorResponse';

export const createUpdateOfferWithVerifiedIncomeThunk = (api: LoanOfferApi) =>
  createAsyncThunk(
    'loanOffer/updateOfferWithVerifiedIncome',
    async (
      data: {
        applicationId: string;
      },
      thunkApi,
    ) => {
      try {
        const { applicationId } = data;

        const result = await api.updateOfferWithVerifiedIncome(applicationId);

        return result;
      } catch (error: unknown) {
        if (error instanceof RequestError) {
          return thunkApi.rejectWithValue(error.toJson());
        }
        return thunkApi.rejectWithValue((error as ErrorResponse).response.data);
      }
    },
  );

export default createUpdateOfferWithVerifiedIncomeThunk;
